import(/* webpackMode: "eager" */ "/vercel/path0/app/team/start/page.jsx");
